var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsBoolean, IsDate, IsNumber, IsString } from 'class-validator';
import { LinkDescriptorDto } from '../shared.js';
export class CreateCustomContractInputDto extends LinkDescriptorDto {
    number;
    date;
    ad_distributor_contragent_id;
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateCustomContractInputDto.prototype, "number", void 0);
__decorate([
    IsDate(),
    __metadata("design:type", Date)
], CreateCustomContractInputDto.prototype, "date", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateCustomContractInputDto.prototype, "ad_distributor_contragent_id", void 0);
export class UpdateCustomContractInputDto extends LinkDescriptorDto {
    number;
    date;
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], UpdateCustomContractInputDto.prototype, "number", void 0);
__decorate([
    IsDate(),
    __metadata("design:type", Date)
], UpdateCustomContractInputDto.prototype, "date", void 0);
export class CreateCustomActInputDto extends LinkDescriptorDto {
    number;
    date;
    is_budget_set_automatically;
    is_date_start_set_automatically;
    is_date_end_set_automatically;
    ad_distributor_contragent_id;
    date_start;
    date_end;
    budget;
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateCustomActInputDto.prototype, "number", void 0);
__decorate([
    IsDate(),
    __metadata("design:type", Date)
], CreateCustomActInputDto.prototype, "date", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], CreateCustomActInputDto.prototype, "is_budget_set_automatically", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], CreateCustomActInputDto.prototype, "is_date_start_set_automatically", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], CreateCustomActInputDto.prototype, "is_date_end_set_automatically", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateCustomActInputDto.prototype, "ad_distributor_contragent_id", void 0);
__decorate([
    IsDate(),
    __metadata("design:type", Date)
], CreateCustomActInputDto.prototype, "date_start", void 0);
__decorate([
    IsDate(),
    __metadata("design:type", Date)
], CreateCustomActInputDto.prototype, "date_end", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateCustomActInputDto.prototype, "budget", void 0);
export class UpdateCustomActInputDto extends LinkDescriptorDto {
    number;
    date;
    is_budget_set_automatically;
    is_date_start_set_automatically;
    is_date_end_set_automatically;
    ad_distributor_contragent_id;
    date_start;
    date_end;
    budget;
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], UpdateCustomActInputDto.prototype, "number", void 0);
__decorate([
    IsDate(),
    __metadata("design:type", Date)
], UpdateCustomActInputDto.prototype, "date", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], UpdateCustomActInputDto.prototype, "is_budget_set_automatically", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], UpdateCustomActInputDto.prototype, "is_date_start_set_automatically", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], UpdateCustomActInputDto.prototype, "is_date_end_set_automatically", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], UpdateCustomActInputDto.prototype, "ad_distributor_contragent_id", void 0);
__decorate([
    IsDate(),
    __metadata("design:type", Date)
], UpdateCustomActInputDto.prototype, "date_start", void 0);
__decorate([
    IsDate(),
    __metadata("design:type", Date)
], UpdateCustomActInputDto.prototype, "date_end", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], UpdateCustomActInputDto.prototype, "budget", void 0);
//# sourceMappingURL=documents.js.map